<template>
  <!-- 年齡確認視窗 -->
  <div v-if="showAgeModal" class="age-modal-backdrop" @keydown.esc.prevent>
    <div
      class="age-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="age-modal-title"
    >
      <!-- 鎖頭圖示 -->
      <div class="lock-icon">
        <div class="lock-shackle"></div>

        <div class="lock-body">
          <span>限</span>
        </div>
      </div>

      <!-- 提示文字 -->
      <div id="age-modal-title" class="age-title">本文含有成人內容</div>

      <div class="age-description">請確定您已年滿18歲</div>

      <!-- 按鈕 -->
      <div class="age-modal-actions">
        <button type="button" class="age-button age-button-enter" @click="confirmAge">
          我已滿18歲
        </button>

        <button type="button" class="age-button age-button-leave" @click="leaveWebsite">
          我未滿18歲
        </button>
      </div>
    </div>
  </div>

  <!-- 導覽列 -->
  <nav class="navbar navbar-expand navbar-dark bg-dark">
    <div class="container">
      <a class="navbar-brand navhome" href="/"> 聯繫我 </a>

      <div class="navbar-collapse collapse">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a
              :class="{
                'nav-link': navl,
                navfont: navf,
                navfont500: navf500,
              }"
              href="/dailyPush"
            >
              每日推薦
            </a>
          </li>

          <li class="nav-item">
            <a
              :class="{
                'nav-link': navl,
                navfont: navf,
                navfont500: navf500,
              }"
              href="/daily"
            >
              每日班表
            </a>
          </li>

          <!-- -->
          <li class="nav-item">
            <a
              :class="{
                'nav-link': navl,
                navfont: navf,
                navfont500: navf500,
              }"
              href="/weekly"
            >
              每周班表
            </a>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              :class="{
                'nav-link': navl,
                navfont: navf,
                navfont500: navf500,
              }"
              href="#"
              id="navbarDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              其他功能
            </a>

            <ul class="bg-dark dropdown-menu" aria-labelledby="navbarDropdown">
              <li>
                <a
                  :class="{
                    'nav-link': navl,
                    navfont: navf,
                    navfont500: navf500,
                  }"
                  href="/search"
                >
                  美容師搜尋
                </a>
              </li>

              <!-- -->
              <li>
                <a
                  :class="{
                    'nav-link': navl,
                    navfont: navf,
                    navfont500: navf500,
                  }"
                  href="/lastComment"
                >
                  最新心得
                </a>
              </li>

              <li>
                <a
                  :class="{
                    'nav-link': navl,
                    navfont: navf,
                    navfont500: navf500,
                  }"
                  href="/commentSearch"
                >
                  心得搜尋
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <!-- 頁面內容 -->
  <router-view />
</template>

<script>
export default {
  data() {
    return {
      navl: true,
      navf: false,
      navf500: false,

      // 控制年齡確認視窗是否顯示
      showAgeModal: false,
    };
  },

  created() {
    console.log("window=" + window.innerWidth);

    // 根據視窗寬度調整導覽列字體大小
    if (window.innerWidth < 500) {
      this.navf500 = true;
    } else if (window.innerWidth < 600) {
      this.navf = true;
    }

    // 檢查使用者是否曾經確認已滿 18 歲
    const ageVerified = localStorage.getItem("ageVerified");

    if (ageVerified !== "true") {
      this.showAgeModal = true;
    }
  },

  methods: {
    // 使用者確認已滿 18 歲
    confirmAge() {
      localStorage.setItem("ageVerified", "true");
      this.showAgeModal = false;
    },

    // 使用者未滿 18 歲
    leaveWebsite() {
      window.location.href = "https://www.google.com";
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>

<style>
/* 導覽列字體 */
.navfont500 {
  font-size: 13px !important;
}

.navfont {
  font-size: 14px !important;
}

.navhome {
  font-size: 18px !important;
  font-weight: bold;
  color: #f4d03f;
}

/* ========================================
   年齡確認視窗
   ======================================== */

/* 黑色半透明背景 */
.age-modal-backdrop {
  position: fixed;
  z-index: 9999;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(0, 0, 0, 0.65);
}

/* 白色視窗 */
.age-modal {
  width: min(92vw, 620px);
  overflow: hidden;

  background: #ffffff;
  text-align: center;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35);
}

/* 鎖頭圖示 */
.lock-icon {
  position: relative;
  width: 270px;
  height: 300px;
  margin: 25px auto 10px;
}

/* 鎖頭上方的 U 型鎖環 */
.lock-shackle {
  position: absolute;
  top: 0;
  left: 50%;

  width: 150px;
  height: 145px;

  border: 34px solid #df1839;
  border-bottom: 0;
  border-radius: 85px 85px 0 0;

  transform: translateX(-50%);
}

/* 鎖頭本體 */
.lock-body {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 190px;
  overflow: hidden;

  background: #df1839;
}

/* 鎖頭斜切陰影 */
.lock-body::after {
  position: absolute;
  top: 0;
  right: 0;

  width: 45%;
  height: 100%;

  background: rgba(170, 0, 25, 0.35);
  clip-path: polygon(100% 0, 100% 100%, 0 100%);
  content: "";
}

/* 「限」字 */
.lock-body span {
  position: relative;
  z-index: 1;

  color: #ffffff;
  font-family: "Microsoft JhengHei", "Noto Sans TC", sans-serif;
  font-size: 145px;
  font-weight: bold;
  line-height: 1;
}

/* 本文含有成人內容 */
.age-title {
  margin-top: 10px;

  color: #111111;
  font-family: "Microsoft JhengHei", "Noto Sans TC", sans-serif;
  font-size: clamp(28px, 5vw, 46px);
  line-height: 1.5;
}

/* 請確定您已年滿18歲 */
.age-description {
  margin-top: 4px;
  margin-bottom: 35px;

  color: #111111;
  font-family: "Microsoft JhengHei", "Noto Sans TC", sans-serif;
  font-size: clamp(26px, 4.5vw, 42px);
  line-height: 1.5;
}

/* 按鈕區域 */
.age-modal-actions {
  display: flex;
  gap: 20px;

  padding: 0 25px 25px;
}

/* 按鈕共用設定 */
.age-button {
  flex: 1;

  min-height: 76px;
  border: none;

  color: #ffffff;
  font-family: "Microsoft JhengHei", "Noto Sans TC", sans-serif;
  font-size: clamp(22px, 3.5vw, 34px);
  cursor: pointer;
  transition: filter 0.2s ease;
}

.age-button:hover {
  filter: brightness(0.9);
}

.age-button:focus {
  outline: 3px solid #333333;
  outline-offset: 3px;
}

/* 我已滿18歲 */
.age-button-enter {
  background-color: #20b34b;
}

/* 我未滿18歲 */
.age-button-leave {
  background-color: #df1839;
}

/* ========================================
   手機版
   ======================================== */

@media (max-width: 600px) {
  .age-modal {
    width: 94vw;
  }

  .lock-icon {
    width: 190px;
    height: 210px;
    margin-top: 18px;
  }

  .lock-shackle {
    width: 110px;
    height: 105px;
    border-width: 25px;
  }

  .lock-body {
    height: 135px;
  }

  .lock-body span {
    font-size: 105px;
  }

  .age-title {
    margin-top: 5px;
  }

  .age-description {
    margin-bottom: 24px;
  }

  .age-modal-actions {
    gap: 10px;
    padding: 0 12px 15px;
  }

  .age-button {
    min-height: 60px;
  }
}
</style>
